import styled, { css } from "styled-components";
import { device } from "../../Utils/device";
import { themes } from "../../Utils/themes";

export enum VariantType {
  Small = "small",
  Medium = "medium",
}

const inputBaseStyle = css`
  font-size: ${themes.textSize.s3};
  border: 1px solid ${themes.colors.border};
  border-radius: 5px;
  padding: 10px;
  max-width: 500px;
  margin-top: 4px;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m1};
    padding: 12px 8px;
  }
`;

export const Section = styled.div`
  padding-top: 80px;
  margin: 0 20px;
  @media ${device.desktop} {
    margin: 0 auto;
    max-width: 800px;
  }
`;
export const SelectedList = styled.div`
  padding: 20px;
  margin: 10px 0;
  border: 1px solid ${themes.colors.border};
  border-radius: 8px;
  @media ${device.desktop} {
    display: flex;
  }
`;

export const SelectedItem = styled.div`
  padding: 5px 20px;
  margin: 10px auto;
  border-bottom: 1px solid ${themes.colors.border};
  max-width: 400px;
  @media ${device.desktop} {
  }
`;

export const FormItemWrap = styled.div`
  width: 100%;
  display: inline-grid;
  margin-top: 20px;
  @media ${device.desktop} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 35px;
  }
`;

export const FormLabelWrap = styled.div`
  width: 100%;
  display: inline-grid;
  max-width: 500px;
  @media ${device.desktop} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const StateLabel = styled.div`
  width: 100%;
  text-align: center;
  font-size: ${themes.textSize.m2};
  @media ${device.desktop} {
    font-size: ${themes.textSize.m3};
  }
`;

export const FormItemLabelWrap = styled.div`
  width: 100%;
`;

export const StateItemLabel = styled.label`
  display: block;
  font-size: ${themes.textSize.s2};
  color: ${themes.colors.text};
  width: 100%;
  max-width: 300px;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m2};
  }
`;

export const FormItemLabel = styled.label`
  display: block;
  font-size: ${themes.textSize.s3};
  font-weight: normal;
  color: ${themes.colors.text};
  max-width: 300px;
  white-space: nowrap;
  @media ${device.desktop} {
    font-size: ${themes.textSize.m2};
  }
`;

export const RequiredLabel = styled.label`
  display: block;
  font-size: ${themes.textSize.s2};
  font-weight: normal;
  color: ${themes.colors.filled};
  margin-left: 5px;
  white-space: nowrap;
  @media ${device.tablet} {
    font-size: ${themes.textSize.s3};
  }
`;
export const TitleLabel = styled.div`
  display: flex;
  align-items: center;
  @media ${device.tablet} {
  }
`;

export const FormItemSmallLabel = styled.label`
  display: block;
  font-size: ${themes.textSize.s1};
  font-weight: normal;
  color: ${themes.colors.text};
  width: 100%;
  @media ${device.tablet} {
    font-size: ${themes.textSize.s2};
    max-width: 320px;
  }
`;

export const Input = styled.input<{ variant: VariantType }>`
  ${inputBaseStyle}
  max-width: 100%;
  @media ${device.tablet} {
    margin: 0;
    max-width: 500px;
    width: ${({ variant }) => {
      switch (variant) {
        case "small":
          return "150px";
        case "medium":
          return "100%";
      }
    }};
  }
`;
export const TextArea = styled.textarea`
  ${inputBaseStyle}
  max-width: 100%;
  height: 80px;
  @media ${device.tablet} {
    margin: 0;
    width: 100%;
    height: 120px;
    max-width: 500px;
  }
`;

export const StateItemWrap = styled.div<{ variant: VariantType }>`
  font-size: ${themes.textSize.s3};
  padding: 10px;
  max-width: 500px;
  max-width: 100%;
  font-weight: bold;
  @media ${device.tablet} {
    margin: 0;
    font-size: ${themes.textSize.m2};
    padding: 12px 16px;
    width: ${({ variant }) => {
      switch (variant) {
        case "small":
          return "150px";
        case "medium":
          return "100%";
      }
    }};
  }
`;

export const OptionLabel = styled.div`
  font-size: ${themes.textSize.s3};
  display: inline-flex;
  align-items: center;
  position: relative;
  width: 100%;
  max-width: 100%;
  max-width: 160px;
  @media ${device.desktop} {
    max-width: 300px;
  }

  &:after {
    position: absolute;
    right: 15px;
    width: 10px;
    height: 7px;
    background-color: #535353;
    clip-path: polygon(0 0, 100% 0, 50% 100%);
    content: "";
    pointer-events: none;
  }
`;

export const OptionSelect = styled.select`
  ${inputBaseStyle}
  appearance: none;
  border-radius: 5px;
  background-color: #fff;
  color: #333333;
  width: 100%;
  -webkit-appearance: none;
  cursor: pointer;
  max-width: 100%;

  @media ${device.desktop} {
  }
`;

export const OptionValue = styled.option`
  ${inputBaseStyle}
`;

export const LinkButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;
  width: 100%;
  height: 40px;
  cursor: pointer;
  @media ${device.desktop} {
    height: auto;
    width: auto;
    min-height: 50px;
    height: 46px;
  }
`;

interface StyeledButtonProps {
  isLoading?: Boolean;
}

export const StyledButton = styled.button<StyeledButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${themes.colors.filled};
  font-weight: bold;
  border-radius: 8px;
  width: 100%;
  max-width: 250px;
  padding: 5px 10px;
  white-space: nowrap;
  font-size: ${themes.textSize.m1};
  color: ${themes.colors.white};
  border: none;
  cursor: pointer;
  @media ${device.desktop} {
    font-size: ${themes.textSize.m2};
    border-radius: 12px;
    max-width: 500px;
  }
  ${(props) => props.isLoading && loadingStyle}
`;

const loadingStyle = css`
  &:disabled {
    background-color: grey;
    cursor: default;
    position: relative;
  }

  &:disabled::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    margin: -10px 0 0 -10px;
    border-radius: 50%;
    border: 2px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

// export const AddButton = styled.button`
//   background: none;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border-radius: 8px;
//   height: 100%;
//   padding: 5px 10px;
//   white-space: nowrap;
//   font-size: 16px;
//   color: ${themes.colors.text};
//   cursor: pointer;
//   max-width: 250px;
//   margin: 0 auto;
// `;

export const AddButton = styled.div`
  padding: 5px;
  font-size: ${themes.textSize.s3};
  color: ${themes.colors.text};
  border-radius: 10px;
  width: fit-content;
  cursor: pointer;
  text-align: center;
  color: ${themes.colors.text};
  background-color: ${themes.colors.caution};
  border-bottom: 5px solid ${themes.colors.disabled};
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m1};
  }
  @media ${device.desktop} {
    padding: 10px;
  }
  &:hover {
    margin-top: 3px;
    background: ${themes.colors.caution};
    border-bottom: 2px solid ${themes.colors.border};
  }
`;
